import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseHubService} from './base-hub.service';
import {ISousSysteme} from '../../_models/SousSysteme';
import {MessageService} from '../local/message.service';
import {ConfigService} from '../local/config.service';
import {IBaseObject} from '../../_models/BaseObject';
import {Store} from '@ngrx/store';
import {MainStoreState} from '../../_store/mainStoreState';
import {
  setSousSystemesSuccessAction,
} from '../../_store/SousSystemeStore/sous-systeme.store';

@Injectable({
  providedIn: 'root',
})
export class SousSystemeService extends BaseHubService<ISousSysteme> {
  constructor(
    http: HttpClient,
    messageService: MessageService,
    configService: ConfigService,
    private store: Store<MainStoreState>
  ) {
    super(
      'sous-systemes',
      'hubs/sousSytemesHub',
      'Sous-systèmes',
      http,
      messageService,
      configService
    );
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
    this.store.dispatch(
      setSousSystemesSuccessAction({payload: data as ISousSysteme[]})
    );
  }
}
